import React, { Fragment, useEffect, useRef } from "react";
import { AppConstant, LangConstant } from "const";
import { useTranslation } from "react-i18next";
import { IconCirclePlus, IconMessage, IconTrash, IconEdit, IconUsers } from "@tabler/icons-react";
import { useRole } from "hooks";

const ActionPopover = ({
  open,
  anchorEl,
  selectedRow,
  type,
  onCloseAction,
  onOpenDepartmentDialog,
  onOpenMemberManagement,
  onCreateChannel,
  onEdit,
  onDelete,
}) => {
  const { t: getLabel } = useTranslation();
  const { isServiceAdmin } = useRole();
  const popoverRef = useRef(null);

  const handleClickFirstButton = () => {
    type === AppConstant.COMPANY_MANAGEMENT_TYPE.unit
      ? onOpenDepartmentDialog(null, selectedRow)
      : onOpenMemberManagement();
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onCloseAction();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onCloseAction]);

  if (!open) return null;

  const rect = anchorEl?.getBoundingClientRect();
  const popoverStyle = rect
    ? {
        position: "fixed",
        top: rect.bottom + 4,
        left: rect.left + rect.width / 2 - 180,
        zIndex: 1050,
      }
    : {};

  return (
    <Fragment>
      <div ref={popoverRef} className="dropdown-menu show" style={{ ...popoverStyle, width: 280, display: "block", padding: "6px 0" }}>
          <button
            className="dropdown-item d-flex align-items-center gap-3"
            style={{ padding: "10px 16px" }}
            onClick={handleClickFirstButton}
          >
            {type === AppConstant.COMPANY_MANAGEMENT_TYPE.unit ? <IconCirclePlus size={20} /> : <IconUsers size={20} />}
            <span>
              {getLabel(
                type === AppConstant.COMPANY_MANAGEMENT_TYPE.unit
                  ? LangConstant.TXT_CREATE_DEPARTMENT
                  : LangConstant.TXT_MEMBER_MANAGEMENT,
              )}
            </span>
          </button>

          {/* TODO: BA yêu cầu tạm ẩn trên môi trường isServiceAdmin */}
          {!isServiceAdmin && (selectedRow?.departmentId || selectedRow?.departmentNumber !== undefined) && (
            <button
              className="dropdown-item d-flex align-items-center gap-3"
              style={{ padding: "10px 16px" }}
              onClick={onCreateChannel}
              disabled={selectedRow?.groupId}
            >
              <IconMessage size={20} />
              <span>{getLabel(LangConstant.TXT_CREATE_CHANNEL)}</span>
            </button>
          )}
          {(selectedRow?.departmentId || selectedRow?.departmentNumber !== undefined) && (
            <Fragment>
              <button
                className="dropdown-item d-flex align-items-center gap-3"
                style={{ padding: "10px 16px" }}
                onClick={onEdit}
              >
                <IconEdit size={20} />
                <span>{getLabel(LangConstant.TXT_EDIT_INFO)}</span>
              </button>
              <button
                className="dropdown-item d-flex align-items-center gap-3"
                style={{ padding: "10px 16px" }}
                onClick={onDelete}
              >
                <IconTrash size={20} />
                <span>{getLabel(LangConstant.TXT_DELETE)}</span>
              </button>
            </Fragment>
          )}
      </div>
    </Fragment>
  );
};

export default ActionPopover;
